import * as React from 'react';

const AlignRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.8 1V19H19V1H17.8ZM15.4 4.6H5.8V9.4H15.4V4.6ZM15.4 10.6H1V15.4H15.4V10.6Z" fill="currentColor"/>
  </svg>
);

export default AlignRight;
